jQuery(document).ready(function(){
    initNavigation();
    initSlider();
    initAccordion();
    initScrollTo();
    initBrowserCheck();
});

// Init Navigation
function initNavigation() {

    var navigation = jQuery('.navigation');
    var nav = jQuery('.nav-menu');
    var has_children = jQuery('.menu-item-has-children > a');
    var mobile_opener = jQuery('.mobile-opener');
    var nav_toggle = jQuery('.nav-toggle');
    var nav_open = jQuery('.nav-open');
    var nav_close = jQuery('.nav-close');

    nav_toggle.on('click', this, function(){
        mobile_opener.toggleClass('open')
        nav_toggle.toggleClass('open')
        navigation.fadeToggle(400)
    })

    has_children.on('click', this, function(event){
        event.preventDefault()
        jQuery(this).parent().toggleClass('open')
        jQuery(this).parent().find('.sub-menu').slideToggle()
    })

    nav.on('click', 'a', function(event){
        mobile_opener.toggleClass('open')
        nav_toggle.toggleClass('open')
        navigation.fadeToggle(400)
    })

    var home_header = jQuery('.header-navigation')
    if(home_header.length){
        var actualBottom = home_header.offset().top + home_header.outerHeight(true);

        jQuery(document).scroll(function() {
            var y = jQuery(this).scrollTop();
            if (y > actualBottom) {
            jQuery('.header-navigation').show();
            } else {
                jQuery('.header-navigation').hide();
            }
        });
    }
}

function initSlider(){
    if ( jQuery('.references__slider').length){
        jQuery('.references__slider').slick({
            dots: true,
            arrows: true,
            infinite: true,
            draggable: true,
            autoplay: false,
            adaptiveHeight: true,
          });
    } 
}

function initAccordion(){
    jQuery('.service__title').on('click', function(){
        jQuery(this).parent().toggleClass('open')
        jQuery(this).parent().find('.service__content').slideToggle();
    })
}

function initScrollTo(){
    var content = jQuery('#contact')
    if(content.length){
        jQuery('a').on('click', this, function(e){
            if(jQuery(this).attr('href') === '#contact'){
                e.preventDefault()
                jQuery('html, body').animate({
                    scrollTop: jQuery("#contact").offset().top - 200
                }, 1000);
           }
        })
    }
}
// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        var ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if ( isIE() ) {
        jQuery('.notice-browser').show();
    }
}